'use client'
import React from 'react';
import {Swiper,SwiperSlide} from 'swiper/react';
import instructors_data from "../../../data/instructors";
import TeamOne from "../../team-member/team-one";
import {Autoplay, Navigation} from "swiper";
import {Link} from "react-router-dom";



function SingleArea({ instructor, image_location_path='01' }) {
  return (
    <div className="edu-course course-style-5 course-style-19">
      <div className="inner">
          <div className="thumbnail">
              <Link to="#">
                  <a>
                      <img src={`/assets/images/team/team-${image_location_path}/${instructor.img}`} alt="team images" />
                  </a>
              </Link>
          </div>
          <div className="content">
              <span className="pre-title">{instructor.title}</span>
              <h6 className="title">
                  <Link to={`/team-details/${instructor.id}`}>
                      <a>{instructor.name}</a>
                  </Link>
              </h6>
          </div>
      </div>
    </div>
  )
}

// swiper setting
const slider_setting = {
    slidesPerView: 1,
    spaceBetween: 0,
    grabCursor: true,
    speed: 1000,
    autoplay: {
        delay: 3000
    },
    breakpoints: {
        600: {
            slidesPerView: 2,
        },
        992: {
            slidesPerView: 3,
        },
        1200: {
          slidesPerView: 4,
      },
      1400: {
          slidesPerView: 5,
      },
  },
  navigation: {
      nextEl: ".swiper-btn-nxt",
      prevEl: ".swiper-btn-prv",
  }
}

const TeamArea = () => {
  return (
    <div className="digital-marketing-course edu-course-area gap-top-equal">
            <div className="container">
                <div className="section-title section-center sal-animate" data-sal-delay="100" data-sal="slide-up" data-sal-duration="800">
                    <span className="pre-title color-secondary">Eğitmenler</span>
                    <h2 className="title">Alanında uzman başarılı eğitmenlerimizi keşfedin.</h2>
                    <span className="shape-line"><i className="icon-19"></i></span>
                </div>
            <Swiper {...slider_setting} modules={[Navigation,Autoplay]} className="digital-marketing-course-activation swiper">
                {instructors_data.map((instructor,i)  => (
                    <SwiperSlide key={i} className="swiper-slide">
                        <SingleArea instructor={instructor}/>
                    </SwiperSlide>
                ))}
                <div className="swiper-navigation">
                    <div className="swiper-btn-nxt cursor-pointer">
                        <i className="icon-west"></i>
                    </div>
                    <div className="swiper-btn-prv cursor-pointer">
                        <i className="icon-east"></i>
                    </div>
                </div>
            </Swiper>
            </div>
        </div>
  );
};

export default TeamArea;